import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { DocumentIncompleteIncidentService } from '../../services/document-incomplete-incident.service';
import { MissingRequirementsModel } from '../../models/missing-requirements.model';
import { MissingRequirementsDocumentModel } from '../../models/missing-requirements-document.model';
import { IncidentMissingRequirementType } from '../../models/enums/incident-missing-requirement-type.enum';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../../incident-modal.component';
import { IncidentService } from '../../services/incident.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '../../services/enums.DataService';

@Component({
    templateUrl: './document-incomplete-modal.html'
})
export class DocumentIncompleteModalComponent extends IncidentModalComponent<MissingRequirementsModel> {
    private service: DocumentIncompleteIncidentService;
    private index = 0;
    public requirementTypes: IncidentMissingRequirementType = new IncidentMissingRequirementType();
    public missingRequirementTypes: any[];
    public missingRequirements: MissingRequirementsDocumentModel[] = [];
    public disableAdd = false;
    public incidentMissingRequirementTypes: any[];

    constructor(location: PlatformLocation,
        fb: UntypedFormBuilder,
        service: DocumentIncompleteIncidentService,
        typeService: IncidentTypeService,
        public dialogRef: MatDialogRef<IncidentModalComponent<MissingRequirementsModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<MissingRequirementsModel>,
        public incidentService: IncidentService,
        public prohibitionService: ProhibitionService,
        modalService: MvdModalService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);

        this.service = service;

        this.missingRequirementTypes = this.requirementTypes.GetActive();
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: MissingRequirementsModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;

        this.missingRequirements = this.data.incident.missingDocuments.slice();

        callback();
    }

    protected onLoadLookups(callback: (error?) => void): void {
        this.service.getLookups().subscribe(r => this.onGetLookups(r.result, callback), callback);
    }

    private onGetLookups(result: any, callback: (error?) => void): void {
        var self = this;

        let lookups: any;

        lookups = result;

        this.incidentMissingRequirementTypes = lookups.incidentMissingRequirementTypes;

        callback();
    }

    public onRequirementTypeChanged(event) {
        if (event == this.requirementTypes.Other.id) {
            this.incidentForm.get('otherRequirement').enable();
        } else {
            this.incidentForm.get('otherRequirement').setValue('');
            this.incidentForm.get('otherRequirement').disable();
        }
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        // for (var x = 0; x < this.index; x++) {
        //    if (this.data.incident.missingDocuments[x] == null) {
        //        this.data.incident.missingDocuments[x] = new MissingRequirementsDocumentModel();
        //        this.data.incident.missingDocuments[x].incidentNumberId = this.data.incident.incidentNumberId;
        //    }

        //    if (!this.data.incident.missingDocuments[x].deleted) {
        //        this.data.incident.missingDocuments[x].incidentMissingRequirementTypeId = this.incidentForm.get('requirementType' + x).value;
        //        this.data.incident.missingDocuments[x].otherRequirement = this.incidentForm.get('otherRequirement' + x).value;
        //    }
        // }

        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    public showOtherRequirement() {
        const val = this.incidentForm.get('requirementTypeList').value;
        return val != null && val.value == this.requirementTypes.Other.id;
    }

    public addRequirement() {
        var self = this;
        const missingRequirementsTypes: IncidentMissingRequirementType = new IncidentMissingRequirementType();
        const selectedObject = this.incidentForm.get('requirementTypeList').value;
        const showOtherRequirement = this.showOtherRequirement();

        if (selectedObject.value != undefined && selectedObject.value > 0) {
            if (showOtherRequirement && (this.incidentForm.get('otherRequirement').value == null || this.incidentForm.get('otherRequirement').value == '')) {
                return false;
            }

            const reqType = missingRequirementsTypes.FromId(selectedObject.value);

            const selectedTypes = self.getSelectedTypes(selectedObject.value);

            if (selectedTypes.length == 0) {

                const type = new MissingRequirementsDocumentModel();
                type.incidentMissingRequirementTypeId = reqType.id;
                type.incidentMissingRequirementTypeDisplayValue = reqType.displayValue;

                if (this.incidentForm.get('otherRequirement') != undefined && this.incidentForm.get('otherRequirement').value != null) {
                    type.otherRequirement = this.incidentForm.get('otherRequirement').value;
                }

                self.data.incident.missingDocuments.push(type);
            }

            this.incidentForm.get('requirementTypeList').reset();

            if (this.incidentForm.get('otherRequirement').value != undefined) {
                this.incidentForm.get('otherRequirement').setValue('');
            }

        }
    }

    public deleteRequirement(id) {
        var self = this;

        if (id > 0) {
            this.data.incident.missingDocuments = this.data.incident.missingDocuments.filter(x => x.incidentMissingRequirementTypeId != id);
        }
    }

    getSelectedTypes(id) {
        return this.data.incident.missingDocuments.filter(x => x.incidentMissingRequirementTypeId == id);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId).subscribe(result => { }, e => this.handleError, () => {
            this.dialogRef.close(true);
        });
    }
}
